// assets/collection-variant-swatches.js
(function () {
  function isCollectionPage() {
    return (
      document.documentElement.classList.contains('template-collection') ||
      document.body.className.includes('template-collection')
    );
  }

  function setImg(img, url) {
    if (!img || !url) return;

    img.src = url;
    img.srcset = '';

    // harmless if theme doesn't use these; helpful if it does
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', '');

    // If wrapped in <picture>, update <source> tags too
    const picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((s) => {
        s.srcset = url;
        s.setAttribute('data-srcset', url);
      });
    }
  }

  function resetHoverSlider(card) {
    // Many themes store slider translate on this element
    const slider = card.querySelector('[data-hover-slider]');
    if (!slider) return;

    // Reset to first slide position
    slider.style.transform = 'translate3d(0px, 0px, 0px)';
  }

  function handleSwatchClick(e) {
    const swatch = e.target.closest('.collection-swatch');
    if (!swatch) return;

    const card = swatch.closest('.grid-item');
    if (!card) return;

    const primary = swatch.dataset.variantPrimary;
    const secondary = swatch.dataset.variantSecondary || primary;
    if (!primary) return;

    // prevent product card link hijack
    e.preventDefault();
    e.stopPropagation();

    // 1) Update default/main image layers
    setImg(card.querySelector('[data-product-image-default] img'), primary);
    setImg(card.querySelector('.product-item__bg img'), primary);

    // 2) Update hover/mobile slider:
    // slide 0 = primary, slide 1 = secondary (primary + 1)
    const slides = card.querySelectorAll('hover-images .product-item__bg__slide img');
    if (slides && slides.length) {
      if (slides[0]) setImg(slides[0], primary);
      if (slides[1]) setImg(slides[1], secondary);
    }
    // 3) Reset slider so it doesn't show “wrong” frame
    resetHoverSlider(card);

    // 4) Active state
    card.querySelectorAll('.collection-swatch').forEach((btn) => btn.classList.remove('is-active'));
    swatch.classList.add('is-active');
  }

  function init() {
    if (!isCollectionPage()) return;

    // capture=true to beat theme card click handlers
    document.addEventListener('click', handleSwatchClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
